/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  addScmSerialNumbers.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date	       : Aug 16, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Aug 16, 2019
 * Description   : ASDS-978: Link Image - Add Serial Numbers - "How to find SCM Serial Numbers"
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : updated the function name(ASDS-1048)
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By           : H224423
 * On           : Nov 20, 2019
 * Description  : Made stepper responsive. ASDS-1304 changes.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-2083 - Updated scuf libraries to latest version. Icons updated.
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Aspire UI enhancements of Phase-2
 *
 ******************************************************************************/

import * as React from 'react';
import { Icon, Grid, Input, Card, InputLabel, Table  } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import ConfigureProductActions from '../redux/actions/configure-product-actions';
import {
    ISCMSerialNumberRowProps,
    ISCMSerialNumbersProps,
    ISCMSerialNumberRowState,
    IFindSCMSectionState
} from '../utils/checkout-interfaces';
import './addScmSerialNumbers.css';

/**
 * @description Displays ADD To Cart button.
 */

function SCMSerialNumbers(props: ISCMSerialNumbersProps) {
    return (
        <Grid className="fullwidthRow">
<Grid.Row>
    <Grid.Column width={9} mWidth={8} xsWidth={12} className="addSerialNumberStep fullwidthRow">
        <Card>
            <Card.Content>
                <Grid id="cp-inputBoxes">
                    <Grid.Row>
                        <Grid.Column width={12} className="add-serial-text">
                            <InputLabel label="Add Serial No" indicator="required" />
                        </Grid.Column>
                    </Grid.Row>
                    {
                        props.productSerialNumbers.map((obj, index) => {
                            return (
                                <SCMSerialNumberRow
                                    key={index}
                                    addNewSerial={props.addNewSerial}
                                    updateSerial={props.updateSerial}
                                    deleteSerial={props.deleteSerial}
                                    index={index}
                                    SCMSerialNumber={obj.serialNumber}
                                    error={obj.error}
                                    serialscount={props.productSerialNumbers.length}
                                    validateSerialOnBlur={props.validateSerialOnBlur}
                                />
                            );
                        })
                    }
                </Grid>
            </Card.Content>
        </Card>
    </Grid.Column>

    <Grid.Column width={3} mWidth={4} xsWidth={12} className="cp-find-scm-col">
        <FindSCMSection/>
    </Grid.Column>
</Grid.Row>
        </Grid>);
}

//ASDS-978
class FindSCMSection extends React.Component<any, IFindSCMSectionState> {

    constructor(props: any) {
        super(props);
        this.state = {
            toggleSection: false,
        };
    }

    render() {
        return (
            <Card className="cp-find-scm-card">
                <Card.Header>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column className="fullwidthRow">
                                <span className="serialHeading">Find Your SCM Serial Number?</span>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column className="fullwidthRow">
                                <div className="addSCMImage" />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Card.Header>
                {this.state.toggleSection &&
                <Card.Content className="cp-find-scm-card-content">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <Table className="cp-find-scm-table">
                                   <Table.Body>
                                   <Table.Row>
                                    <Table.Cell singleLine={true}>
                                    STEP 1:
                                    </Table.Cell>
                                    <Table.Cell>
                                        SEARCH FOR SERIAL NUMBER BELOW THE PANEL
                                    </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                    <Table.Cell singleLine={true}>
                                    STEP 2:
                                    </Table.Cell>
                                    <Table.Cell>
                                    FIND OUT SERIAL NUMBER AS DISPLAYED IN ABOVE IMAGE
                                    </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                    <Table.Cell singleLine={true}>
                                    STEP 3:
                                    </Table.Cell>
                                    <Table.Cell>
                                    ADD SERIAL NUMBER
                                    </Table.Cell>
                                    </Table.Row>
                                    </Table.Body>
                                </Table>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column className="cp-read-more fullwidthRow">
                                <span className="cp-read-more-text"> READ MORE ON OUR ONLINE MANUAL <a href="#">ASPIRE PRODUCT HONEYWELL</a></span>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Card.Content>
                }
                <Card.Footer>
                    {!this.state.toggleSection &&
                        <div
                            id="moreBttn"
                            className="cp-view-more-button"
                            onClick={() => this.setState({ toggleSection: true })}>
                            VIEW MORE
                                    <Icon root="common" name="caret-down" size="small" />
                        </div>}
                    {this.state.toggleSection &&
                        <div id="lessBttn" className="cp-view-less-button" onClick={() => this.setState({ toggleSection: false })}>
                            VIEW LESS
                                    <Icon root="common" name="caret-up" size="small" />
                        </div>}
                </Card.Footer>
            </Card>
        );
    }
}

class SCMSerialNumberRow extends React.Component<ISCMSerialNumberRowProps, ISCMSerialNumberRowState> {
    render() {
        return (
            <Grid.Row key={this.props.index}>
                <Grid.Column width={10} sWidth={9} className="padd-bottom-5">
                    <Input
                        className="input-example"

                        indicator="required"
                        value={this.props.SCMSerialNumber}
                        error={this.props.error}
                        onChange={(value) => {
                        this.props.updateSerial(value, this.props.index);
                    }}
                        onBlur={() => {
                            this.props.validateSerialOnBlur();
                        }}
                    />
                </Grid.Column>
                <Grid.Column width={2} sWidth={3}>
                    {this.props.serialscount !== 1 && <Icon root="common" name="delete" size="medium" className="slider-controls-delete" onClick={() => {this.props.deleteSerial(this.props.index); }} />}
                    { this.props.serialscount - 1 === this.props.index && <Icon root="common" name="badge-plus" className="slider-controls-plus" size="medium" onClick={!this.props.error ? () => {this.props.addNewSerial(this.props.index); } : null} /> }
                </Grid.Column>
            </Grid.Row>
        );
    }
}

const mapDispatchToProps = {
    addNewSerial: ConfigureProductActions.addNewSerial,
    updateSerial: ConfigureProductActions.updateSerial,
    deleteSerial: ConfigureProductActions.deleteSerial,
    validateSerialOnBlur: ConfigureProductActions.validateSerialOnBlur
};

function mapStateToProps(state) {
    return {
        productSerialNumbers: state.configProductData.payload.serialNumbers
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SCMSerialNumbers);